module.exports = __webpack_public_path__ + "static/media/nemu.945b3b5c.jpg";